// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root--lAK","dropdownWrapper":"Navigation_dropdownWrapper--z7n","hidden":"Navigation_hidden--Awy"};